'use client';
import React from 'react';

const categories = [
  { name: 'Home Cleaning', icon: '🧹', count: '324 tasks' },
  { name: 'Delivery', icon: '📦', count: '198 tasks' },
  { name: 'Assembly', icon: '🔧', count: '156 tasks' },
  { name: 'Moving Help', icon: '🚚', count: '142 tasks' },
  { name: 'Yard Work', icon: '🌿', count: '127 tasks' },
  { name: 'Mounting', icon: '📺', count: '115 tasks' },
];

export default function SideBox() {
  return (
    <div className="py-16 bg-white mt-12 mb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 animate-fade-in">
            Popular Categories
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-gray-500 animate-fade-in delay-100">
            Browse tasks by category to find what you need help with
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((category, index) => (
            <div 
              key={category.name} 
              className="group bg-gray-50 rounded-lg p-6 text-center cursor-pointer hover:bg-purple-50 transition-all duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-lg animate-fade-in-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="text-3xl transform group-hover:scale-110 transition-transform duration-300">
                {category.icon}
              </div>
              <h3 className="mt-4 font-medium text-gray-900 group-hover:text-purple-600 transition-colors duration-300">
                {category.name}
              </h3>
              <p className="mt-1 text-sm text-gray-500 group-hover:text-purple-500 transition-colors duration-300">
                {category.count}
              </p>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeIn 0.6s ease-out forwards;
        }
        .animate-fade-in-up {
          opacity: 0;
          animation: fadeInUp 0.6s ease-out forwards;
        }
        .delay-100 {
          animation-delay: 100ms;
        }
      `}</style>
    </div>
  );
}